module.exports = __webpack_public_path__ + "../resources/img/icon-edit.38f0d4a9.svg";